import $store from '@/store'

window.phonePaymentCallback = async userValidation => {
  $store.commit('auth/SET_USER_VALIDATION', userValidation)
}
